import React from 'react';
import ReactDatetime from 'react-datetime';
import 'moment/locale/pt-br';

import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from 'reactstrap';

import { isEqual } from 'date-fns';

const DatePickerIsValidCHA = ({ showIconCalendar = true, ...props }) => {
  const controlChange = (values) => {
    let date = values;
    if (values._d) {
      date = values._d.toLocaleDateString('pt-br');

      return props.valueController(props.fieldName, date);
    }

    if (values) {
      return props.valueController(props.fieldName, date);
    }

    return props.valueController(props.fieldName, '');
  };
  const controlFunction = () => {
    props.requestTableAvulsa();
  };

  const valid = (current) => {
    const newArray = [];
    const datesDaysOff = props.daysOffObject.daysOff;
    const datesTimeShift = props.daysOffObject.timeShifts;

    const newDatesTimeShift = datesTimeShift.map((item) => {
      return { ...item, date: item.requestedDateShift };
    });

    datesDaysOff.map((item) => {
      const test = newDatesTimeShift.find((itemTimeShift) => {
        return itemTimeShift.dateTimeShift === item.date;
      });
      if (test) {
        newArray.push(test);
      } else {
        newArray.push(item);
      }
    });

    const newArrayNext = !!newArray.find((item) => {
      return isEqual(current._d, new Date(item.date));
    });

    return !newArrayNext;
  };

  return (
    <>
      <FormGroup style={{ marginBottom: '0px', width: '240px' }}>
        <InputGroup className="input-group-alternative">
          {showIconCalendar && (
            <InputGroupAddon addonType="prepend">
              <InputGroupText style={{ border: '1px solid #c4c4c4' }}>
                <i className="ni ni-calendar-grid-58" />
              </InputGroupText>
            </InputGroupAddon>
          )}
          <ReactDatetime
            isValidDate={valid}
            closeOnSelect={true}
            closeOnTab={true}
            name={props.fieldName}
            className="reactDate"
            inputProps={{
              style: {
                border: '1px solid #c4c4c4'
              }
            }}
            onChange={(event) => {
              controlChange(event);
              controlFunction(event);
            }}
            timeFormat={false}
            locale="pt-br"
            value={props.defaultValue}
          />
        </InputGroup>
      </FormGroup>
    </>
  );
};

export default DatePickerIsValidCHA;
